<template>
  <div class="animated fadeIn"  id="listar-usuarios">
    <div class="card card-default">
      <div class="card-header">
        <i class="icon-share"></i> Sincronização de Projetos
      </div>
      <div class="card-body">
        <h3 style="text-align: center; margin-bottom: 35px;"><i class="icon-user"></i> {{ usuario.nome }}</h3>

        <div class="row">
        <div class="col-md-3" v-if="usuario.contratacao === formaContratacao.profissional">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text" id="basic-addon3">CPF</span>
            </div>
            <input type="text" class="form-control" id="basic-url" aria-describedby="basic-addon3" v-model="usuario.cpf" disabled>
          </div>
        </div>

        <div class="col-md-3" v-if="usuario.contratacao  === formaContratacao.eps">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text" id="basic-addon3">Contrato</span>
            </div>
            <input type="text" class="form-control" id="basic-url" aria-describedby="basic-addon3" v-model="usuario.contrato" disabled>
          </div>
        </div>

        <div class="col-md-3">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text" id="basic-addon3">Capacidade</span>
            </div>
            <input type="time" class="form-control" id="basic-url" aria-describedby="basic-addon3" v-model="usuario.capacidade">
          </div>
        </div>

        <div class="col-md-6">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text" id="basic-addon3">E-mail</span>
            </div>
            <input type="text" class="form-control" id="basic-url" aria-describedby="basic-addon3" v-model="usuario.email" disabled>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text" id="basic-addon3">Gestor</span>
            </div>
            <select type="text" class="form-control" id="basic-url" aria-describedby="basic-addon3" v-model="usuario.gestor" disabled>
              <option value="">Selecione...</option>
              <option value="0">A definir</option>
              <option value="1">Saule Vilson Feversani</option>
            </select>
          </div>
        </div>

        <div class="col-md-6">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text" id="basic-addon3">Forma de Contratação</span>
            </div>
            <select type="text" class="form-control" id="basic-url" aria-describedby="basic-addon3" v-model="usuario.contratacao" :disabled="!isAdmin">
              <option v-for="item of dados.tiposContratacao" v-bind:key="item.id" :value="item.id">{{ item.tipo_contratacao }}</option>
            </select>
          </div>
        </div>
      </div>

      <button class="btn btn-primary pull-right" v-on:click="salvar"><i class="icon-check"></i> Salvar</button>
      <button class="btn btn-default pull-right" style="margin-right: 5px;" v-on:click="voltar"><i class="icon-action-undo"></i> Cancelar</button>
      </div>
    </div>

    <notifications group="editar-usuario" />
  </div>
</template>

<style lang="scss">
  // #listar-usuarios {
    // Estilos
  // }
</style>

<script>
  import Uteis from '@/mixins/utils.js';

  export default {
    mixins: [
      Uteis,
    ],

    data() {
      return {
        id: null,
        usuario: {},
        formaContratacao: {
          profissional: 1,
          eps: 2,
        },
        dados: {
          tiposContratacao: [],
        },
      };
    },

    computed: {
      isAdmin() {
        return this.$acl.check('isAdmin');
      },
    },

    mounted() {
      this.id = this.$route.params.id;

      this.pesquisarUsuario();
      this.getTiposContratacao();
    },

    methods: {
      async pesquisarUsuario() {
        try {
          this.$events.$emit('loading', true);

          const { data: usuarioView } = await this.$http.get(`/v-usuario/${this.id}`);
          const { data: usuario } = await this.$http.get(`/usuario/${this.id}`);

          this.carregarDadosUsuario(usuarioView, usuario);
        } catch(e) {
          this.notificar('Ocorreu um erro ao realizar a pesquisa pelo usuário!', 'editar-usuario');
        } finally {
          this.$events.$emit('loading', false);
        }
      },

      carregarDadosUsuario(usuarioView, usuario) {
        this.usuario = {
          nome: usuarioView.nome,
          email: usuarioView.email,
          capacidade: this.getDuracao(usuario.horas_liberadas),
          contratacao: usuario.tipos_contratacao_id,
          cpf: 'A definir',
          contrato: 'A definir',
          gestor: 0,
        };
      },

      voltar() {
        this.$router.push({ path: '/gestor/usuarios' })
      },

      async getTiposContratacao() {
        try {
          this.dados.tiposContratacao = [];

          const { data: response } = await this.$http.get('/tipo-contratacao');

          this.dados.tiposContratacao = response.tipos_contratacao;
        } catch(e) {
          this.notificar('Ocorreu um erro ao pesquisar as Formas de Contratações.', 'editar-usuario');
        }
      },

      async salvar() {
        try {
          this.$events.$emit('loading', true);

          await this.$http.post('/usuario', this.getDto());

          this.notificar('Usuário atualizado com sucesso!', 'editar-usuario', 'success');
        } catch(e) {
          this.notificar('Ocorreu um erro ao salvar o Usuário.', 'editar-usuario');
        } finally {
          this.$events.$emit('loading', false);
          this.pesquisarUsuario();
        }
      },

      getDto() {
        const values = this.usuario.capacidade.split(':');
        const dto = {
          id: this.id,
          horas_liberadas: this.getSegundos(values[0], values[1]),
        };

        if (this.isAdmin) {
          dto.tipos_contratacao_id = this.usuario.contratacao;
        }

        return dto;
      },
    },
  }
</script>
